import Grid from '@klv/utils/grid';
import styled, { css } from 'styled-components';
import type { IChartTheme, TChartBackgroundColor } from '../types';
import Typography from '@klv/atoms/typography';

export const StyledGrid = styled(Grid)`
  grid-template-columns: 100%;
  grid-template-areas: 'col1';
`;

export const StyledChart = styled.div<{ $backgroundColor: TChartBackgroundColor; }>`
  ${({ theme, $backgroundColor }) => `
    background-color: ${theme.chart[$backgroundColor as keyof IChartTheme].backgroundColor};
    width: 100%;
    ${theme.globalPadding}
  `}
`;

export const ChartHeader = styled.div<{ $textColor: TChartBackgroundColor; }>`
  ${({ theme, $textColor }) => `
    color: ${theme.chart[$textColor as keyof IChartTheme].textColor};
  `}
`;

export const Headline = styled(Typography)`
  text-align: center;
`;

export const SubHeadline = styled(Typography)`
  text-align: center;
  padding-top: 1.6rem;
`;

export const LeftHeadline = styled(Typography)`
`;

export const LeftSubheadline = styled(Typography)`
  padding-top: 1.6rem;
`;


export const ChartInfo = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const BarandLineChartHeadline = styled(Typography)<{ $textColor: TChartBackgroundColor; $alignment?: string; }>`
  padding: 3.2rem 0;
  ${({ theme, $alignment, $textColor }) => `
      text-align: ${$alignment === 'center' ? 'center' : 'left'};
      color: ${theme.chart[$textColor as keyof IChartTheme].textColor};
    ${theme.screenSize.s768.mediaQuery} {
      padding-top: 4rem;
      padding-bottom: 4.8rem;
    }
    ${theme.screenSize.s1366.mediaQuery} {
      padding-top: 4.8rem;
      padding-bottom: 5.6rem;
    }
  `}
`;

export const ChartHeadline = styled(Typography)<{ $textColor: TChartBackgroundColor; $alignment?: string; }>`
  ${({ theme }) => theme.fonts.sohneMono.regular}
  
  padding-top: 3.2rem;
  ${({ theme, $textColor, $alignment }) => `
    text-align: ${$alignment === 'center' ? 'center' : 'left'};
    color: ${theme.chart[$textColor as keyof IChartTheme].textColor};
    display: inline-block;

    ${theme.screenSize.s768.mediaQuery} {
      padding-top: 4rem;
    }
    ${theme.screenSize.s992.mediaQuery} {
      padding-top: 4.8rem;
    }
  `}
`;

export const BarCharts = styled.div<{ $multiple: boolean; }>`
  display: flex;
  flex-direction: column;

  ${({ theme, $multiple }) => `
    ${theme.screenSize.s1366.mediaQuery} {
      ${$multiple && css`
        flex-direction: row;
        gap: 10.4rem;
      `}
    }
  `}
`;
export const PieCharts = styled.div<{ $multiple: boolean; }>`
  display: flex;
  flex-direction: column;

  ${({ theme, $multiple }) => `
    ${theme.screenSize.s1366.mediaQuery} {
      ${$multiple && css`
        flex-direction: row;
        gap: 10.4rem;
        flex: 1;
      `}
    }
  `}
`;

export const DisclaimerText = styled(Typography)<{ $textColor: TChartBackgroundColor; }>`
  padding-top: 2.4rem;
  ${({ theme, $textColor }) => `
    color: ${theme.chart[$textColor as keyof IChartTheme].textColor};
    ${theme.screenSize.s576.mediaQuery} {
      padding-top: 3.2rem;
    }
  `}
`;
